const color = {
  orange: "#FDA237",
  gray: "#7B7472",
  borderGray: "#DADADA",
  red: "#DC2626",
};

export default color;
